// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 583 ? "group-foo" : chunkId) + "-legacy." + {"380":"f6e05741","451":"c194699a","454":"9de7de69","496":"5653361c","583":"8cbada8c"}[chunkId] + ".js";
};